import React, { useEffect, useRef, useState } from 'react';
import BaseDialog from '../BaseDialog';
import { Button, Stack, Typography } from '@mui/material';

const SSEErrorDialog = ({ isVisible }) => {
  const [isReloading, setIsReloading] = useState(false);
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleReconnect = () => {
    if (isReloading) return;

    setIsReloading(true);

    if (isMountedRef.current) {
      window.location.reload();
    }
  };

  return (
    <BaseDialog isVisible={isVisible} onClose={() => {}} clickOutsideToClose={false}>
      <Stack spacing={3} alignItems="center" sx={{ textAlign: 'center' }}>
        <Typography variant="h6" component="p" sx={{ fontWeight: 700 }}>
          ネットワークエラーが発生しました。再接続をお試しください。
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button variant="contained" onClick={handleReconnect} disabled={isReloading}>
            再接続
          </Button>
          <Button variant="outlined" href="/">
            ホームに戻る
          </Button>
        </Stack>
      </Stack>
    </BaseDialog>
  );
};

export default SSEErrorDialog;
